@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    height: 100vh;
    min-height: max(var(--min-height), 500px);

    @media ($below-mobile) {
        display: flex;
        justify-content: center;
        align-items: center;
        height: auto;
    }
}

.textContainer {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    position: absolute;
    inset: var(--spacer-32) 0;
    z-index: 1;

    @media ($below-mobile) {
        position: static;
        padding: var(--spacer-32) 10%;
    }
}

.text {
    grid-column: 3 / span 8;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.topRight,
.topLeft,
.bottomRight,
.bottomLeft {
    --gaps: calc(var(--columns) - 1);
    --gap-width: calc(var(--labui-grid-gap) * var(--gaps));
    --column-width: calc(var(--labui-grid-column-width) * var(--columns, 4));

    position: absolute;
    width: calc(
        var(--column-width) + var(--gap-width) + var(--container-margin)
    );

    img {
        // Got a weird transient layout bug without setting width/height
        width: 100%;
        height: 100%;
        position: relative;
    }

    @media ($below-mobile) {
        --columns: 2 !important;
    }
}

.topLeft,
.bottomLeft {
    left: 0;

    img {
        left: calc(var(--offset-percent) * -1);
    }
}

.topRight,
.bottomRight {
    right: 0;

    img {
        right: calc(var(--offset-percent) * -1);
    }
}

.topLeft,
.topRight {
    top: 0;
}

.bottomLeft,
.bottomRight {
    bottom: 0;
}
